import React from 'react';
import './Legal.css';

const EULA = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>End User License Agreement</h1>
        <p className="legal-date">Last Updated: October 22, 2024</p>

        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing and using the Paragon Wheel Repair application ("the Application"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the terms of this agreement, you are not authorized to use or access the Application.
          </p>
        </section>

        <section>
          <h2>2. License Grant</h2>
          <p>
            Subject to the terms of this Agreement, we grant you a limited, non-exclusive, non-transferable, revocable license to use the Application for your internal business purposes in accordance with this Agreement.
          </p>
        </section>

        <section>
          <h2>3. Restrictions</h2>
          <p>You agree not to, and you will not permit others to:</p>
          <ul>
            <li>License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the Application</li>
            <li>Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the Application</li>
            <li>Remove, alter or obscure any proprietary notice on the Application</li>
            <li>Use the Application in any manner that could damage, disable, overburden, or impair the Application</li>
          </ul>
        </section>

        <section>
          <h2>4. Intellectual Property</h2>
          <p>
            The Application, including all content, features, and functionality, is owned by Paragon Wheel Repair and is protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
          </p>
        </section>

        <section>
          <h2>5. User Data</h2>
          <p>
            You retain all rights to the data you input into the Application ("User Data"). You grant us a license to use, store, and process User Data solely for the purpose of providing the Application services to you. We will not share your User Data with third parties except as necessary to provide the Application services or as required by law.
          </p>
          <p>
            For more information about how we collect, use, and safeguard your data, please review our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>
            The Application may integrate with third-party services (such as QuickBooks). Your use of such third-party services is subject to their respective terms and conditions and privacy policies. We are not responsible for the practices or policies of third-party services. The Application is not affiliated with, endorsed, or sponsored by Intuit Inc. or QuickBooks.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            THE APPLICATION IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. We do not warrant that the Application will be uninterrupted, secure, or error-free.
          </p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL PARAGON WHEEL REPAIR BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
          </p>
        </section>

        <section>
          <h2>9. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Paragon Wheel Repair from any claims, losses, damages, liabilities, including legal fees and expenses, arising out of your use or misuse of the Application, your violation of this Agreement, or your violation of any rights of a third party.
          </p>
        </section>

        <section>
          <h2>10. Term and Termination</h2>
          <p>
            This Agreement shall remain in effect until terminated by you or Paragon Wheel Repair. We may terminate or suspend your access to the Application immediately, without prior notice or liability, for any reason, including if you breach this Agreement.
          </p>
        </section>

        <section>
          <h2>11. Modifications</h2>
          <p>
            We reserve the right to modify this Agreement at any time. We will notify users of any material changes by updating the "Last Updated" date of this Agreement. Your continued use of the Application after such modifications constitutes your acceptance of the updated Agreement.
          </p>
        </section>

        <section>
          <h2>12. Legal Compliance</h2>
          <p>
            You agree to use the Application in compliance with all applicable laws and regulations, including but not limited to data protection and export control laws.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            This Agreement shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            If you have any questions about this Agreement, please contact us at:
          </p>
          <p>
            Paragon Wheel Repair<br/>
            Email: info@paragonwheel.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default EULA;

